
import Bitcoin from "../../../assets/filled/Bitcoin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BitcoinIcon({ className, dataTestid = "BitcoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bitcoin data-testid={dataTestid} className={classes} {...rest} />
  );
}
